<app-header-modal color="secondary-2" [title]="title">
  <i class="uil uil-times" (click)="close()" status></i>
</app-header-modal>

<div class="upper-section">
  <div class="file-upload">
    <label for="file-import" class="custom-image-upload">
      {{!importedFileName ? 'Importar ordem por arquivo' : importedFileName}}
    </label>
    <input id="file-import" type="file" accept=".xlsx" (change)="onFileSelected($event)">
  </div>
  <form [formGroup]="form">
    <mat-form-field appearance="outline">
      <mat-label>Número da ordem</mat-label>
      <input matInput appAlphanumericInput placeholder="Número da ordem" formControlName="orderNumber">
      <mat-error *ngIf="form.controls.orderNumber?.hasError('pattern')">
        Use apenas letras, números ou hífens
      </mat-error>
      <mat-hint>Digite apenas letras, números ou hífens</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Descrição da ordem de separação</mat-label>
      <textarea matInput
        placeholder="Descrição da ordem de separação" 
        formControlName="description" rows="1">
      </textarea>
    </mat-form-field>
  </form>
</div>
<div class="mid-section">
  <h3>Produtos</h3>
  <form [formGroup]="form">
    <mat-form-field appearance="outline">
      <mat-label>Código do Item</mat-label>
      <input matInput
             placeholder="Código do Item"
             formControlName="sku"
             [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayedString">
        <mat-option *ngFor="let product of products" [value]="product">
          {{ product.name + ' - ' + product.sku }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Quantidade</mat-label>
      <input matInput type="number" min="1" placeholder="Quantidade" formControlName="quantity">
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="addManuallyToTable(form.value)"
      [disabled]="form.get('sku')?.invalid || form.get('quantity')?.invalid">
      Inserir Item
    </button>
  </form>
</div>
<div class="table-section">
  <table mat-table [dataSource]="dataSource" *ngIf="showTable">
    <ng-container matColumnDef="sku">
      <th mat-header-cell *matHeaderCellDef class="header-cell"> Código do Item </th>
      <td mat-cell *matCellDef="let element"> {{element.sku}} </td>
    </ng-container>

    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef class="header-cell"> Descrição </th>
      <td mat-cell *matCellDef="let element"> {{element.description}} </td>
    </ng-container>

    <ng-container matColumnDef="quantity">
      <th mat-header-cell *matHeaderCellDef class="header-cell"> Quantidade </th>
      <td mat-cell *matCellDef="let element"> {{element.quantity}} </td>
    </ng-container>

    <ng-container matColumnDef="availability">
      <th mat-header-cell *matHeaderCellDef class="header-cell"> Disponibilidade </th>
      <td mat-cell *matCellDef="let element">
        <div *ngIf="element.checkingAvailability" class="spinner-cell" aria-live="polite">
          <mat-progress-spinner [diameter]="18" mode="indeterminate" matTooltip="Verificando..." aria-label="Verificando disponibilidade"></mat-progress-spinner>
        </div>
        <div *ngIf="!element.checkingAvailability">
          <span class="avail-dot" [ngClass]="{'ok': element.availability, 'missing': !element.availability}"
            [matTooltip]="(element.availableQty != null ? (element.availableQty + ' unidades') : '0 unidades')"
            matTooltipPosition="below"
            aria-hidden="true">
          </span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="header-cell action"> </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <button (click)="deleteFromTable(i)" class="delete-button" aria-label="Remover item">
          <i class="uil uil-trash delete-icon" aria-hidden="true"></i>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row class="header" *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row class="row" *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
<div class="buttons">
  <button mat-stroked-button class="gray-2" (click)="close()">cancelar</button>
  <button mat-raised-button class="primary-1" (click)="submit()"
    [disabled]="form.controls.orderNumber?.invalid">
    confirmar
  </button>
</div>